var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"d-flex align-center justify-center text-uppercase"},_vm.$listeners),[_c('ArrowSvg'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$root.allLanguages[_vm.$language.current].back))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }